function readErrorCodeFromRecord(record: Record<string, unknown>): string | null {
  if (typeof record['errorCode'] === 'string') {
    return record['errorCode'];
  }
  return null;
}

/** Reads API validation errorCode (e.g. recaptcha_challenge_required). */
export function extractWidgetApiErrorCode(error: unknown): string | null {
  if (error && typeof error === 'object' && 'error' in error) {
    const nested = extractWidgetApiErrorCodeFromBody(
      (error as { error: unknown }).error,
    );
    if (nested) {
      return nested;
    }
  }

  return extractWidgetApiErrorCodeFromBody(error);
}

function extractWidgetApiErrorCodeFromBody(body: unknown): string | null {
  if (Array.isArray(body)) {
    for (const item of body) {
      if (item && typeof item === 'object') {
        const code = readErrorCodeFromRecord(item as Record<string, unknown>);
        if (code) {
          return code;
        }
      }
    }
    return null;
  }

  if (body && typeof body === 'object') {
    return readErrorCodeFromRecord(body as Record<string, unknown>);
  }

  return null;
}


/** Parses B2C widget API error bodies (array of { errorMessage } or object shapes). */
export function extractWidgetApiErrorMessage(body: unknown): string | null {
  if (Array.isArray(body)) {
    const messages = body
      .map((item) => {
        if (!item || typeof item !== 'object') {
          return null;
        }
        const record = item as Record<string, unknown>;
        if (typeof record['errorMessage'] === 'string') {
          return record['errorMessage'];
        }
        if (typeof record['message'] === 'string') {
          return record['message'];
        }
        return null;
      })
      .filter((message): message is string => !!message);

    return messages.length > 0 ? [...new Set(messages)].join(' ') : null;
  }

  if (body && typeof body === 'object') {
    const record = body as Record<string, unknown>;
    if (typeof record['errorMessage'] === 'string') {
      return record['errorMessage'];
    }
    if (typeof record['message'] === 'string') {
      return record['message'];
    }
    if (typeof record['error'] === 'string') {
      return record['error'];
    }
  }

  if (typeof body === 'string' && body.length > 0) {
    return body;
  }

  return null;
}
